var map = {
	"./BossPuzzle/BossPuzzle": 186,
	"./BossPuzzle/BossPuzzle.jsx": 186,
	"./BossPuzzle/BossPuzzle.spec": 501,
	"./BossPuzzle/BossPuzzle.spec.jsx": 501,
	"./BossPuzzle/BossPuzzle.stories": 590,
	"./BossPuzzle/BossPuzzle.stories.jsx": 590,
	"./EightQueens/EightQueens": 183,
	"./EightQueens/EightQueens.jsx": 183,
	"./EightQueens/EightQueens.spec": 649,
	"./EightQueens/EightQueens.spec.jsx": 649,
	"./EightQueens/EightQueens.stories": 650,
	"./EightQueens/EightQueens.stories.jsx": 650,
	"./KnightsTour/KnightsTour": 184,
	"./KnightsTour/KnightsTour.jsx": 184,
	"./KnightsTour/KnightsTour.spec": 651,
	"./KnightsTour/KnightsTour.spec.jsx": 651,
	"./KnightsTour/KnightsTour.stories": 652,
	"./KnightsTour/KnightsTour.stories.jsx": 652,
	"./Sudoku/Sudoku": 187,
	"./Sudoku/Sudoku.css": 653,
	"./Sudoku/Sudoku.jsx": 187,
	"./Sudoku/Sudoku.scss": 6496,
	"./Sudoku/Sudoku.spec": 654,
	"./Sudoku/Sudoku.spec.jsx": 654,
	"./Sudoku/Sudoku.stories": 655,
	"./Sudoku/Sudoku.stories.jsx": 655,
	"./Tetris/Tetris": 185,
	"./Tetris/Tetris.css": 656,
	"./Tetris/Tetris.jsx": 185,
	"./Tetris/Tetris.scss": 6497,
	"./Tetris/Tetris.spec": 657,
	"./Tetris/Tetris.spec.jsx": 657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6232;